import React from 'react';
import * as Sentry from '@sentry/react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorId: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to Sentry
    try {
      Sentry.captureException(error, {
        contexts: {
          react: {
            componentStack: errorInfo?.componentStack || 'No stack available'
          }
        }
      });
    } catch (sentryError) {
      console.error('Failed to report error to Sentry:', sentryError);
      Sentry.captureException(error);
    }

    // Get the error ID from Sentry
    const errorId = Sentry.lastEventId();
    this.setState({ errorId });

    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p>We've been notified and will look into it.</p>
          {this.state.errorId && (
            <p style={{ color: '#666', fontSize: '12px' }}>
              Error ID: {this.state.errorId}
            </p>
          )}
          <button
            onClick={() => window.location.href = '/'}
            style={{
              padding: '10px 20px',
              marginTop: '20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Go to Home
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default Sentry.withProfiler(ErrorBoundary);
